import { useState, useRef } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import { addStationWithCustomerId } from "../../../../../services/clearing/customers";
import Dropdown from "../../../../../components/inputs/Dropdown";
import { AddCustomerDialog } from "../../../../Customer/components/AddCustomerDialog";

export const AssignStationListItem = ({ customerOptions: initialCustomerOptions, stationId }) => {
  const [customerId, setCustomerId] = useState("");
  const [customerOptions, setCustomerOptions] = useState(initialCustomerOptions);
  const [addCustomerVisible, setAddCustomerVisible] = useState(false);
  const toast = useRef(null);

  const handleCustomerChange = (value) => {
    setCustomerId(value?.code || "");
  };

  const handleSubmit = async (customerIdToSave) => {
    const idToUse = customerIdToSave || customerId;
    const success = await addStationWithCustomerId({ stationId, customerId: idToUse });
    if (success) {
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Station assigned successfully",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to assign customer to station",
        life: 3000,
      });
    }
  };

  const handleCustomerCreated = (createdCustomer) => {
    const newOption = {
      name: createdCustomer?.account_holder_name,
      code: createdCustomer?.id,
    };
    setCustomerOptions((prev) => [...prev, newOption]);
    setCustomerId(createdCustomer?.id);
    setAddCustomerVisible(false);

    // Auto-assign the new customer to the station
    handleSubmit(createdCustomer?.id);
  };

  return (
    <div className="flex align-items-center gap-2 w-full">
      <Toast ref={toast} />
      <AddCustomerDialog
        visible={addCustomerVisible}
        onClose={() => setAddCustomerVisible(false)}
        onCustomerCreated={handleCustomerCreated}
      />
      <Dropdown
        options={customerOptions}
        value={
          customerOptions.find(
            (option) => option.code === customerId
          ) || null
        }
        onChange={handleCustomerChange}
        placeholder="Select Customer"
        className="w-full"
        searchable={true}
      />
      <Button
        icon="pi pi-user-plus"
        onClick={() => setAddCustomerVisible(true)}
        outlined
        className="flex-shrink-0"
        tooltip="Add New Customer"
        tooltipOptions={{ position: "top" }}
      />
      <Button
        icon="pi pi-trash"
        onClick={() => setCustomerId("")}
        outlined
        className="flex-shrink-0"
      />
      <Button
        icon="pi pi-save"
        onClick={() => handleSubmit()}
        className="flex-shrink-0"
      />
    </div>
  );
};
